const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/notifications.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { checkSubscriptionStatusQuery, subscriptionsQuery } from "@/queries/push-notifications";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/notifications")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  head: () => ({
    meta: [{
      title: i18n.t("notifications.meta.title")
    }, {
      name: "description",
      content: i18n.t("notifications.meta.description")
    }]
  }),
  loader: async ({
    context
  }) => {
    const {
      queryClient
    } = context;
    const apiKey = context.cookies?.["push-notifications-api-key"];
    if (apiKey) {
      await queryClient.prefetchQuery(checkSubscriptionStatusQuery(apiKey));
      await queryClient.prefetchQuery(subscriptionsQuery(apiKey));
    }
    return {
      apiKey
    };
  }
});